// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarOperadoresResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /agenda/buscar_operadores/{franquia_id}
 *
 * Returns the list of operators for a franchise. See
 * Agenda_BuscarOperadoresRow for per-row shape.
 */
import type { Agenda_BuscarOperadoresRow } from './Agenda_BuscarOperadoresRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarOperadoresResponseDados {
operadores: Agenda_BuscarOperadoresRow[]
}

export type Agenda_BuscarOperadoresResponse = ApiResponse<Agenda_BuscarOperadoresResponseDados>;

registerResponseContract('Agenda_BuscarOperadoresResponse', {
  operadores: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'string',  required: true },
      franquia_id:     { type: 'number',  required: true },
      nome:            { type: 'string',  required: true },
      operador_avatar: { type: 'string',  required: false },
    },
  },
})
